module.exports = __webpack_public_path__ + "static/img/1-1.050f361.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/1-1.png
// module id = d3Z/
// module chunks = 0